import React from 'react';
import DatePicker from 'material-ui/DatePicker';
import Toggle from 'material-ui/Toggle';

const optionsStyle = {
  // maxWidth: 255,
  marginRight: 'auto',
  display: 'flex',
  height: 70,
  lineHeight: '4.7',
};

const datePickerStyle = {
  flex: 1,
  padding: '0 15px',
  // width:200
}

/**
 * This example allows you to set a date range, and to toggle `autoOk`, and `disableYearSelection`.
 */
export default class DatePickerRange extends React.Component {
  constructor(props) {
    super(props);

    const minDate = new Date();
    const maxDate = new Date();
    minDate.setFullYear(minDate.getFullYear());
    minDate.setHours(0, 0, 0, 0);
    maxDate.setFullYear(maxDate.getFullYear());
    maxDate.setHours(0, 0, 0, 0);

    this.state = {
      minDate: minDate,
      maxDate: maxDate,
    };
  }

  handleChangeMinDate = (event, date) => {
    this.setState({
      minDate: date,
    });
    this.props.onChange(this.state)
  };

  handleChangeMaxDate = (event, date) => {
    this.setState({
      maxDate: date,
    });
    this.props.onChange(this.state)
  };


  render() {
    return (
      <div style={this.props.outerStyle}>
       
        <div style={optionsStyle}>
          <DatePicker
            style={datePickerStyle}
            onChange={this.handleChangeMinDate}
            autoOk={true}
            // floatingLabelText="from"
            textFieldStyle ={{width:150}}
            maxDate={this.state.maxDate}
            // minDate={this.state.minDate}
            defaultDate={this.state.minDate}

          />
          <DatePicker
            style={datePickerStyle}
            onChange={this.handleChangeMaxDate}
            autoOk={true}
            // floatingLabelText="to"
            minDate={this.state.minDate}
            maxDate={new Date()}
            textFieldStyle ={{width:150}}
            defaultDate={this.state.maxDate}
            
          />
         
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/DatePickerRange.js